/* eslint-disable */

import * as THREE from 'three'
import RadialGradientsShader from './Shaders/RadialGradients.js'

class RadialGradients
{
    /**
     * Constructor
     */
    constructor(options)
    {
        // Options
        this.camera = options.camera
        this.color = typeof options.color !== 'undefined' ? options.color : 0x100407  // 0x100407 | 0x10040a
        this.width = typeof options.width !== 'undefined' ? options.width : 2
        this.height = typeof options.height !== 'undefined' ? options.height : 2
        this.depth = typeof options.depth !== 'undefined' ? options.depth : 2
        this.radius = typeof options.radius !== 'undefined' ? options.radius : 2

        // Container
        this.container = new THREE.Object3D()

        // Set plans
        this.setPlans()
    }

    /**
     * Set plans
     */
    setPlans()
    {
        // Set up
        this.plans = []

        let plansCoordinates = [
        ]

        for(let i = 0; i < 10; i++)
        {
            plansCoordinates.push({
                x: 0 + (Math.random() - 0.5) * 3, 
                y: 0 + (Math.random() - 0.5) * 3, 
                z: 0 + (Math.random() - 0.5) * 3
            })
        }

        for(let i = 0; i < plansCoordinates.length; i++)
        {
            const planCoordiantes = plansCoordinates[i]
            let plan = {}

            plan.x = planCoordiantes.x
            plan.y = planCoordiantes.y
            plan.z = planCoordiantes.z

            // Geometry
            plan.geometry = new THREE.PlaneBufferGeometry(this.radius, this.radius, 1)

            // Material
            plan.material = new THREE.ShaderMaterial({
                side: THREE.DoubleSide,
                transparent: true,
                uniforms:
                {
                    color: { value: new THREE.Color(this.color) }
                },
                blending: THREE.AdditiveBlending,
                vertexShader: RadialGradientsShader.vertexShader,
                fragmentShader: RadialGradientsShader.fragmentShader
            })

            // Mesh
            plan.mesh = new THREE.Mesh(plan.geometry, plan.material)
            plan.mesh.position.x = plan.x
            plan.mesh.position.y = plan.y
            plan.mesh.position.z = plan.z

            plan.material.depthTest = false

            // Save
            this.container.add(plan.mesh)
            this.plans.push(plan)
        }
    }

    /**
     * Update
     */
    update()
    {
        let cameraWorldVector = new THREE.Vector3()
        this.camera.localToWorld(cameraWorldVector)

        // Each plan
        for(let i = 0; i < this.plans.length; i++)
        {
            let plan = this.plans[i]

            // Look at camera
            plan.mesh.lookAt(cameraWorldVector)
        }
    }
}

export default RadialGradients


// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/RadialGradients.js